<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="row" v-if="!loading">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Zarządzanie ogłoszeniami
                    </div>
                    <div class="card-body">
                        <data-table
                            :items="data.announcements"
                            :fields="fields"
                            delete
                            v-on:delete="handleDelete"
                            v-if="data.announcements.length"
                        >
                            <template v-slot:type="row">
                                <span v-if="row.value == 0">Czat globalny</span>
                                <span v-if="row.value == 1">Wiadomość prywatna</span>
                                <span v-if="row.value == 2">Poke</span>
                            </template>
                            <template v-slot:server_groups="row">
                                <server-groups v-if="row.value.length" :groups="row.value" />
                                <span v-else>Wszystkie</span>
                            </template>
                            <template v-slot:message_interval="row">
                                <span v-if="row.value > 0">{{ row.value }} minut</span>
                                <span v-else>Jednorazowe</span>
                            </template>
                            <template v-slot:ended_at="row">
                                <span v-if="row.value">{{ row.value | moment("DD-MM-YYYY HH:mm:ss") }}</span>
                                <span v-else>Jednorazowe</span>
                            </template>
                            <template v-slot:created_at="row">
                                {{ row.value | moment("DD-MM-YYYY HH:mm") }}
                            </template>
                            <template v-slot:last_message="row">
                                <span v-if="row.value">{{ row.value | moment("DD-MM-YYYY HH:mm:ss") }}</span>
                                <span v-else>---</span>
                            </template>
                            <template v-slot:client="row">
                                <client :client="row.value" withAvatar/>
                            </template>
                        </data-table>
                        <div class="d-flex justify-content-center">
                            <button v-b-modal.modal-add class="btn btn-success">
                                <i class="fa fa-plus"></i> Dodaj ogłoszenie
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="modal-add"
            centered
            title="Dodaj nowe ogłoszenie"
            title-class="font-18"
            size="lg"
            v-if="!loading"
        >
            <div>
                <form class="needs-validation" @submit.prevent="() => {}">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="message">Wiadomość</label>
                                <textarea
                                    id="message"
                                    v-model="newAnnouncement.message"
                                    :class="{ 'is-invalid': $v.newAnnouncement.message.$error }"
                                    class="form-control"
                                    placeholder="Nowy partner - RO-BOT.net"
                                ></textarea>
                                <div v-if="$v.newAnnouncement.message.$error" class="invalid-feedback">
                                    <span v-if="!$v.newAnnouncement.message.required">Wiadomość jest wymagana.</span>
                                    <span v-if="!$v.newAnnouncement.message.maxLength">Wiadomość jest za długa.</span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="type">Typ wiadomości</label>
                                <select
                                    id="type"
                                    v-model="newAnnouncement.type"
                                    :class="{ 'is-invalid': $v.newAnnouncement.type.$error }"
                                    class="form-control"
                                >
                                    <option value="null" disabled selected>Wybierz opcję</option>
                                    <option value="0">Czat globalny</option>
                                    <option value="1">Wiadomość prywatna</option>
                                    <option value="2">Poke</option>
                                </select>
                                <div v-if="$v.newAnnouncement.type.$error" class="invalid-feedback">
                                    <span v-if="!$v.newAnnouncement.type.required">Typ wiadomości jest wymagany.</span>
                                </div>
                            </div>
                            <div class="form-group" v-if="newAnnouncement.type && newAnnouncement.type != 0">
                                <label for="server_groups">Określone grupy</label>
                                <multiselect
                                    v-model="newAnnouncement.server_groups"
                                    id="server_groups"
                                    :custom-label="groupName"
                                    :options="data.serverGroups"
                                    :multiple="true"
                                    track-by="name"
                                    selectLabel="Wybierz"
                                    selectedLabel="Wybrany"
                                    placeholder="Wybierz coś"
                                    deselectLabel="Usuń"
                                    :closeOnSelect="false"
                                >
                                    <template slot="tag" slot-scope="{ option, remove, index }">
                                        <span class="multiselect__tag" :key="index">
                                            <server-group :group="option" withName/>
                                            <i tabindex="1" @keypress.enter.prevent="remove(option)"  @mousedown.prevent="remove(option)" class="multiselect__tag-icon"></i>
                                        </span>
                                    </template>
                                    <template slot="option" slot-scope="props"><server-group :group="props.option" withName/></template>
                                </multiselect>
                                <small>Jeśli chcesz powiadomić wszystkich, zostaw to pole puste</small>
                            </div>
                            <div class="form-group">
                                <label for="with_interval">Wiadomość co określony czas</label><br>
                                <switches
                                    id="with_interval"
                                    v-model="newAnnouncement.with_interval"
                                    color="primary"
                                    type-bold="true"
                                    class="m-2"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="newAnnouncement.with_interval">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="ended_at_date">Data zakończenia</label>
                                <input
                                    id="ended_at_date"
                                    v-model="newAnnouncement.ended_at_date"
                                    :class="{ 'is-invalid': $v.newAnnouncement.ended_at_date.$error }"
                                    class="form-control"
                                    type="date"
                                />
                                <div v-if="$v.newAnnouncement.ended_at_date.$error" class="invalid-feedback">
                                    <span v-if="!$v.newAnnouncement.ended_at_date.required">Końcowa data jest wymagana.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="ended_at_time">Godzina zakończenia</label>
                                <input
                                    id="ended_at_time"
                                    v-model="newAnnouncement.ended_at_time"
                                    :class="{ 'is-invalid': $v.newAnnouncement.ended_at_time.$error }"
                                    class="form-control"
                                    type="time"
                                />
                                <div v-if="$v.newAnnouncement.ended_at_time.$error" class="invalid-feedback">
                                    <span v-if="!$v.newAnnouncement.ended_at_time.required">Końcowy czas jest wymagany.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="message_interval">Interwał wysyłania <small>(w minutach)</small></label>
                                <input
                                    id="message_interval"
                                    v-model="newAnnouncement.message_interval"
                                    :class="{ 'is-invalid': $v.newAnnouncement.message_interval.$error }"
                                    class="form-control"
                                    type="number"
                                />
                                <div v-if="$v.newAnnouncement.message_interval.$error" class="invalid-feedback">
                                    <span v-if="!$v.newAnnouncement.message_interval.required">Interwał jest wymagany.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="success"
                        size="sm"
                        class="float-right mx-1"
                        @click="handleAdd"
                    >
                        <i class="fa fa-plus"></i> Utwórz ogłoszenie
                    </b-button>
                    <b-button
                        v-if="isOnline && newAnnouncement.message && newAnnouncement.type"
                        variant="info"
                        size="sm"
                        class="float-right mx-1"
                        @click="handleView"
                    >
                        <span v-if="!sendingView">
                            <i class="fa fa-eye"></i> Podglą ogłoszenia
                        </span>
                        <b-spinner v-else class="mx-4" small label="Loading..."/>
                    </b-button>
                </div>
            </template>
        </b-modal>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import AnnouncementsService from "@/services/announcements.service";
import {
    notificationMethods
} from "@/state/helpers";
import {
    required,
    requiredIf
} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import Switches from "vue-switches";

/**
 * Starter component
 */
export default {
    name: "Announcements",
    components: {Layout, PageHeader, Multiselect, Switches},
    data() {
        return {
            title: "Ogłoszenia",
            items: [
                {
                    text: "Admin",
                    href: "/"
                },
                {
                    text: "Ogłoszenia",
                    active: true
                }
            ],
            loading: true,
            sendingView: false,
            data: {},
            fields: [
                {key: "id", sortable: true},
                {key: "message", label: "Wiadomość"},
                {key: "type", label: "Typ"},
                {key: "server_groups", label: "Grupy serwerowe"},
                {key: "message_interval", label: "Interwał"},
                {key: "ended_at", label: "Czas wygaśnięcia"},
                {key: "client", label: "Autor"},
                {key: "last_message", label: "Ostatnie wysłanie"},
                {key: "created_at", label: "Data utworzenia", sortable: true},
            ],
            newAnnouncement: {}
        };
    },
    validations: {
        newAnnouncement: {
            message: {required, maxLength: (value, model) => {
                if (!model.type)
                    return !value || value.length <= 30;

                if (model.type == 0)
                    return !value || value.length <= 1000;
                else if (model.type == 1)
                    return !value || value.length <= 1000;
                else
                    return !value || value.length <= 100
            }},
            with_interval: {},
            type: {required},
            server_groups: {},
            ended_at_date: {required: requiredIf((model) => model.with_interval)},
            ended_at_time: {required: requiredIf((model) => model.with_interval)},
            message_interval: {required: requiredIf((model) => model.with_interval)},
        }
    },
    computed: {
        isOnline() {
            return this.$store.getters['auth/user'].status == 'online';
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...notificationMethods,
        groupName(field) {
            return field.name+' - ('+field.sgid+')';
        },
        sanitize() {
            this.data.announcements = this.data.announcements.map(item => {
                return {
                    ...item,
                    _rowVariant: item.active ? 'isActive' : ''
                }
            })
        },
        loadData() {
            this.loading = true;

            AnnouncementsService.getAll().then(
                response => {
                    this.data = response.data;
                    this.sanitize();
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        handleView() {
            this.sendingView = true;

            AnnouncementsService.view({
                message: this.newAnnouncement.message,
                type: Number(this.newAnnouncement.type),
            }).then(
                () => {
                    this.success("Ogłoszenie zostało do Ciebie wysłane w celach podglądowych!");
                    this.sendingView = false;
                },
                error => {
                    console.log(error);
                    this.sendingView = false;
                }
            )
        },
        handleAdd() {
            this.$v.newAnnouncement.$touch();

            if (this.$v.newAnnouncement.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-add");
                this.loading = true;

                AnnouncementsService.save({
                    message: this.newAnnouncement.message,
                    server_groups: this.newAnnouncement.server_groups?.map(s => s.sgid),
                    type: Number(this.newAnnouncement.type),
                    ended_at: this.newAnnouncement.ended_at_date ? (this.newAnnouncement.ended_at_date + " " + this.newAnnouncement.ended_at_time) : null,
                    message_interval: this.newAnnouncement.message_interval
                }).then(
                    () => {
                        this.success("Ogłoszenie zostało dodane!");
                        this.newAnnouncement = {};
                        this.loadData();
                        this.$v.newAnnouncement.$reset();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        handleDelete(row) {
            this.loading = true;

            AnnouncementsService.delete(row.id).then(
                () => {
                    this.success("Ogłoszenie zostało usunięte");
                    this.loadData();
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        }
    }
};
</script>